import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import requestErrorTreatment from "@shared/utils/requestErrorTreatment";
import { tiledeskStatusQueryKey } from "@modules/tiledesk/services/queries/getTiledeskStatus";
import { TiledeskStatus } from "@modules/tiledesk/types";
import { EnableTiledeskInput, enableTiledeskService } from "./service";

export function useEnableTiledeskMutation(agreementId: string) {
  const { open } = useNotification();
  const translate = useTranslate();
  const queryClient = useQueryClient();

  return useMutation<TiledeskStatus, ApiError, EnableTiledeskInput>({
    mutationFn: enableTiledeskService,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tiledeskStatusQueryKey(agreementId),
      });
      open?.({
        type: "success",
        message: translate("tiledesk.success.enable"),
      });
    },
    onError: (error: ApiError) => {
      requestErrorTreatment(error, open);
    },
  });
}
